import { Badge } from '@/shared/components/ui/badge'

const STATUS_VARIANTS = {
  pending: 'bg-amber-100 text-amber-700 hover:bg-amber-100',

  sent: 'bg-green-100 text-green-700 hover:bg-green-100',
}

export default function QuoteStatusBadge({ status }) {
  const isSent = status?.toLowerCase() === 'sent'

  return (
    <Badge
      className={`rounded-full border-0 px-3 py-1 text-xs font-semibold ${
        isSent ? STATUS_VARIANTS.sent : STATUS_VARIANTS.pending
      }`}
    >
      {isSent ? 'Sent' : 'Pending'}
    </Badge>
  )
}
